module.exports = __webpack_public_path__ + "static/img/5.2adb042.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/5.png
// module id = 5jSW
// module chunks = 0